import { Component, Input, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FirebaseAuthService } from 'src/app/shared/providers/firebase-auth.service';
import { RenderJob } from '../render-flow.model';
import { RenderFeedbackService } from '../render-feedback.service';
import { renderDialogPanes } from '../render-home';
import { RenderFeedbackDialogComponent, RenderFeedbackDialogData } from './render-feedback-dialog.component';

// The line under the videos on the downloads page (owner, 2026-10-20: no thumbs there, a quiet way
// to say something went wrong — it emails the team, as before). It opens the feedback form; the
// preview has the thumbs instead (render-vote). Never a popup by itself. Once sent it says thanks,
// and stays that way for this model on this device.
@Component({
  selector: 'app-render-rating',
  templateUrl: './render-rating.component.html',
  styleUrls: ['./render-rating.component.scss'],
})
export class RenderRatingComponent implements OnChanges {
  @Input() job?: RenderJob;

  public sent = false;

  constructor(
    private readonly dialog: MatDialog,
    private readonly feedback: RenderFeedbackService,
    private readonly firebaseAuth: FirebaseAuthService,
  ) {}

  ngOnChanges(): void {
    this.sent = !!this.job && this.feedback.given(this.job, 'videos');
  }

  public open(): void {
    if (!this.job) {
      return;
    }
    openRenderFeedback(this.dialog, this.firebaseAuth, { job: this.job, stage: 'videos', rating: null }).afterClosed().subscribe(() => this.ngOnChanges());
  }
}

// The form, for the line under the videos and the preview's thumbs-down alike.
export function openRenderFeedback(dialog: MatDialog, firebaseAuth: FirebaseAuthService, data: Omit<RenderFeedbackDialogData, 'userName'>) {
  const user = firebaseAuth.currentUser;
  return dialog.open<RenderFeedbackDialogComponent, RenderFeedbackDialogData, 'sent' | undefined>(RenderFeedbackDialogComponent, {
    data: { ...data, userName: (user?.displayName || '').trim() || user?.email || '' },
    autoFocus: 'dialog',
    panelClass: renderDialogPanes('render-feedback-pane'),
    ariaLabelledBy: 'render-feedback-title',
  });
}
